import { ContentBlock, GuideTypes, Metadata, Step } from "../models";
import { Entry } from "contentful";
import { convertToHtmlString, convertToPlainTextString, findContent, parseIntoImage } from "../utils";
import { FieldMapping, UserContextValues } from "../types";

export const createStep = (
  fieldMapping: FieldMapping<Step>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): Step | undefined => {
  const label = findContent(entries, fieldMapping.label, guideType);
  const text = findContent(entries, fieldMapping.text, guideType);
  const image = findContent(entries, fieldMapping.image, guideType);
  const imageHeader = findContent(entries, fieldMapping.imageHeader, guideType);
  const title = findContent(entries, fieldMapping.title, guideType);

  const shouldInlineTextAndImage =
    fieldMapping.shouldInlineTextAndImage as unknown as boolean;
  const smallMarginImage = fieldMapping.smallMarginImage as unknown as boolean;

  return {
    label: convertToHtmlString(label?.fields.richContent, userContextValues),
    title: convertToPlainTextString(title?.fields.richContent),
    text: convertToHtmlString(text?.fields.richContent, userContextValues),
    image: parseIntoImage(image?.fields.richContent?.content[0].data, true),
    imageHeader: convertToHtmlString(
      imageHeader?.fields.richContent,
      userContextValues,
    ),
    substep: convertToHtmlString(
      findContent(entries, fieldMapping.substep, guideType)?.fields.richContent,
      userContextValues,
    ),
    shouldInlineTextAndImage: shouldInlineTextAndImage,
    smallMarginImage: smallMarginImage,
    isNextStepContainer: fieldMapping.isNextStepContainer as unknown as boolean
  };
};
